module.exports = __webpack_public_path__ + "img/Email - Welcome Tetant.921a686.png";